export default __webpack_public_path__ + "static/media/logo_greenbg.0f4be12e.svg";